/* eslint-disable @next/next/no-img-element */
'use client';
import Login from '@/components/Login/Login';
import React from 'react';

// Login page
const LoginPage: React.FC = () => {
    return (
        <div>
            <Login />
        </div>
    );
};

export default LoginPage;
